<template>
  <div class="id-mode-section">
    <div class="id-mode-cards">
      <div
        class="id-mode-card"
        :class="{ 'id-mode-card--active': modelValue === 'auto' }"
        @click="$emit('update:modelValue', 'auto')">
        <div class="id-mode-card__radio">
          <div class="id-mode-card__radio-dot"></div>
        </div>
        <div class="id-mode-card__content">
          <div class="id-mode-card__title">Автоматична генерація</div>
          <div class="id-mode-card__desc">{{ autoDescription }}</div>
        </div>
      </div>
      <div
        class="id-mode-card"
        :class="{ 'id-mode-card--active': modelValue === 'manual' }"
        @click="$emit('update:modelValue', 'manual')">
        <div class="id-mode-card__radio">
          <div class="id-mode-card__radio-dot"></div>
        </div>
        <div class="id-mode-card__content">
          <div class="id-mode-card__title">Ввести вручну</div>
          <div class="id-mode-card__desc">
            Використати існуючий ID, наприклад при міграції даних
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'PackageIdModeSelect',
  props: {
    modelValue: {
      type: String as () => 'auto' | 'manual',
      default: 'auto',
    },
    autoDescription: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped lang="scss">
.id-mode-cards {
  display: flex;
  gap: 10px;
}

.id-mode-card {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition:
    border-color 0.2s,
    background-color 0.2s;
  user-select: none;

  &:hover {
    border-color: rgba(var(--v-theme-primary), 0.5);
  }

  &--active {
    border-color: rgb(var(--v-theme-primary));
    background-color: rgba(var(--v-theme-primary), 0.04);
  }

  &__radio {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #bdbdbd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    transition: border-color 0.2s;

    .id-mode-card--active & {
      border-color: rgb(var(--v-theme-primary));
    }
  }

  &__radio-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: rgb(var(--v-theme-primary));
    opacity: 0;
    transition: opacity 0.2s;

    .id-mode-card--active & {
      opacity: 1;
    }
  }

  &__content {
    flex: 1;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.4;
    color: #212121;
  }

  &__desc {
    font-size: 12px;
    color: #757575;
    margin-top: 3px;
    line-height: 1.4;
  }
}
</style>
